<template>
    <div>
        <div v-if="isLoaded" :class="$style.parent">
            <div :class="$style.notfound_bg"></div>
            <div :class="$style.notfound">
                <div :class="$style.notfound_404">
                    <h1>404</h1>
                </div>
                <h6 class="text-center m-4">
                    {{language.lang("Are you lost? We couldn't find the page you looking for")}}</h6>
                <a @click="redirect('about')" :class="$style.contact_btn">{{language.lang("About us")}}</a>
                <a @click="redirect('/')" :class="$style.home_btn">{{language.lang('Home page')}}</a>
            </div>
        </div>
    </div>
</template>
<script>
    import language from "@/utils/language";
    import oracle from "@/utils/oracle";
    import Lawyer from "@/views/Lawyer";

    export default {
        name: 'NotFound',
        components: {Lawyer},
        data() {
            return {
                id: null,
                isLoaded: false,
                language: language,
            }
        },
        methods: {
            redirect(page) {
                this.$router.push(page);
            }
        }, mounted() {
            try {
                let index = this.$router.history.current.path.substring(1)
                oracle.axios('lawyer/check', {"index": index}, (res) => {
                    if (res.data == null) {
                        this.isLoaded = true
                    } else {
                        this.$router.push({name: 'lawyer', params: {id: index}})
                    }
                })
            } catch (e) {
                this.isLoaded = true
            }
        }
    };
</script>
<style module>
    .parent {
        position: relative;
        height: 100vh
    }

    .parent .notfound_bg {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: white;
        background-size: cover
    }

    .parent .notfound_bg:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: white
    }

    .parent .notfound {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%)
    }

    .notfound {
        max-width: 910px;
        width: 100%;
        line-height: 1.4;
        text-align: center
    }

    .notfound .notfound_404 {
        position: relative;
        height: 200px
    }

    .notfound .notfound_404 h1 {
        position: absolute;
        left: 50%;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        font-size: 220px;
        font-weight: 900;
        margin: 0;
        color: #427BD5;
        text-transform: uppercase;
        letter-spacing: 10px
    }

    .notfound h2 {
        font-size: 22px;
        font-weight: 700;
        text-transform: uppercase;
        color: #222222;
        margin-top: 20px;
        margin-bottom: 15px
    }

    .notfound .home_btn,
    .notfound .contact_btn {
        display: inline-block;
        font-weight: 700;
        text-decoration: none;
        background-color: transparent;
        border: 2px solid transparent;
        text-transform: uppercase;
        padding: 13px 25px;
        font-size: 18px;
        border-radius: 40px;
        margin: 7px;
        -webkit-transition: .2s all;
        transition: .2s all;
    }

    .notfound .home_btn:hover,
    .notfound .contact_btn:hover {
        opacity: .9
    }

    .notfound .home_btn {
        color: white !important;
        background: #427BD5;
    }

    .notfound .contact_btn {
        border: #427BD5 solid 3px;
        color: #427BD5 !important;
    }

    .notfound-social {
        margin-top: 25px
    }

    .notfound-social > a {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        width: 40px;
        font-size: 14px;
        color: #222222;
        margin: 0 6px;
        -webkit-transition: .2s all;
        transition: .2s all
    }

    .notfound-social > a:hover {
        color: #222222;
        background-color: #222222;
        border-radius: 50%
    }

    @media only screen and (max-width: 767px) {
        .notfound .notfound_404 h1 {
            font-size: 182px
        }
    }

    @media only screen and (max-width: 480px) {
        .notfound .notfound_404 {
            height: 146px
        }

        .notfound .notfound_404 h1 {
            font-size: 146px
        }

        .notfound h2 {
            font-size: 16px
        }

        .notfound .home_btn,
        .notfound .contact_btn {
            font-size: 14px
        }
    }
</style>